import { jsx as t, jsxs as h } from "react/jsx-runtime";
import "react";
var r = (i) => /* @__PURE__ */ h("svg", {
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...i,
  children: [
    /* @__PURE__ */ t("rect", {
      width: 20,
      height: 20,
      fill: "#F5F5F5"
    }),
    /* @__PURE__ */ t("rect", {
      width: 1876,
      height: 988,
      transform: "translate(-1392 -380)",
      fill: "white"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V20H20V0Z",
      fill: "#F0F0F0"
    }),
    /* @__PURE__ */ t("path", {
      d: "M20 0H0V10H20V0Z",
      fill: "#A2001D"
    })
  ]
});
export {
  r as default
};
